import { InitialDetails, TextArea } from "@fla/components";
import { selectConsentOrdersBase } from "pages/ConsentOrders/consentOrdersSelectors";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";

interface IProps {
  formId: string;
  store: InitialDetails;
  onSubmit: (values: InitialDetails) => void;
}
export default function Confirmation({ onSubmit, formId, store }: IProps) {
  const { initialDetails } = useSelector(selectConsentOrdersBase);

  const { handleSubmit, control } = useForm({
    defaultValues: store
  });

  const lastSubmittedAt =
    initialDetails.updatedAt?.seconds && new Date(initialDetails.updatedAt.seconds * 1000).toLocaleDateString();

  return (
    <form id={formId} className="space-y-5" onSubmit={handleSubmit(onSubmit)}>
      <div className="mb-8 pb-8 border-b">
        <h3 className="text-center">Complete</h3>
      </div>

      <p className="text-md ">You have completed the details about the relationship.</p>
      <p className="text-md ">You can write any further comments about the questions you answered so far here.</p>

      <TextArea
        title="Comment (Optional)"
        control={control}
        name="user.comments_relationship"
        id="user.comments_relationship"
        placeholder="details"
      />

      {/* <p className="text-md mt-4 ">
        In the next step, we are now going to ask you to please provide details
        about all the assets and debts in your sole name, in {spouseFirstName}'s
        sole name, jointly held or held with third parties.
      </p> */}
      <br />
      <br />

      {initialDetails && initialDetails?.isCompleted && initialDetails?.updatedAt ? (
        <p className="my-5 font-light italic">
          Initial details lastly saved at <b>{lastSubmittedAt}</b>
        </p>
      ) : null}
    </form>
  );
}
